/* RESPONSIBLE TEAM: team-proactive-support */
import { belongsTo } from '@ember-data/model';
import RulesetLink from '../ruleset-link';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';

export default RulesetLink.extend({
  object: belongsTo('series/condition', { async: false }),
  objectType: objectTypes.condition,
});
